import { RootState } from '@/stores'
import { setCurrentPropertiesTab } from '@/stores/selected-properties-tab'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'

type PropTypes = {
  options: string[]
  contents: React.ReactNode[]
}

const PropertiesTabBar = ({ options, contents }: PropTypes) => {
  const dispatch = useDispatch()
  const selectedTab = useSelector((state: RootState) => state.selectedPropertiesTab.currentTab)

  return (
    <div>
      <div className="px-3.5 py-3 flex flex-row items-center justify-evenly">
        {
          options.map((option, index) => (
            <button
              key={index}
              onClick={() => dispatch(setCurrentPropertiesTab(index))}
              className={classNames('text-sm font-semibold leading-[14.4px]', {
                'text-gray-900': selectedTab === index,
                'text-gray-600': selectedTab !== index,
              })}
            >
              {option}
            </button>
          ))
        }
      </div>
      <div className="border-t border-gray-100" />
      <div>
        { contents.at(selectedTab) ?? contents.at(contents.length - 1) ?? <></> }
      </div>
    </div>
  )
}

export default PropertiesTabBar
